import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "../Slice/Authentication/SignInSlice";
import forgotPasswordReducer from "../Slice/Authentication/ForgotPasswordSlice";
import signUpReducer from "../Slice/Authentication/SignUpSlice";
import fetchRoles from "../Slice/Dropdowns/FetchRoleSlice";
import fetchUsers from "../Slice/Users/UsersListSlice";
import GetUserById from "../Slice/Users/GetUserById";
import setPasswordReducer from "../Slice/Authentication/SetPasswordSlice";
import paginationReducer from "../Slice/Common/PaginationSlice";
import setMFAReducer from "../Slice/Authentication/setMFASlice";
import getCustomerListReducer from "../Slice/Customers/CustomerListSlice";
import customerDataReducer from "../Slice/Customers/CustomerSlice";
import customerDetailsByIdReducer from "../Slice/Customers/GetCUstomerByIdSlice";
import getPlansList from "../Slice/Plans/GetPlansListSlice";
import planbyIdReducer from "../Slice/Plans/GetPlanByIdSlice";
import getDetailsfromZipcodeReducer from "../Slice/Common/GetStateFromZipcode";
import getFeaturesListReducer from "../Slice/Dropdowns/GetFeaturesSlice";
import getAssistantListReducer from "../Slice/Assistant/AssistantsListSlice";
import getAssistantReducer from "../Slice/Assistant/GetASsistantById";
import getTemplatesListReducer from "../Slice/Assistant/GetTemplateListSlice";
import getTransactionListReducer from "../Slice/Transaction/GetTransactionListSlice";
import getTransactionsByIdReducer from "../Slice/Transaction/GetTransactionsByIdSlice";
import getContactListReducer from "../Slice/Contacts/GetContactsListSlice";
import hasUnsavedChanges from "../Slice/Common/SelectedTabSlice";
import ChatDetailsReducer from "../Slice/Chats/ChatDetailsSlice";
import ChatListReducer from "../Slice/Chats/ChatListSlice";
import GetCountMetricsReducer from "../Slice/Dashboard/AdminDashboard/GetCountMetricsSlice";
import GetRevenueSummaryReducer from "./../Slice/Dashboard/AdminDashboard/GetRevenueSummarySlice";
import GetTotalCustomersReducer from "../Slice/Dashboard/AdminDashboard/GetTotalCustomersSice";
import GetTotalAmountReceivedReducer from "./../Slice/Dashboard/AdminDashboard/GetTotalAmountReceivedSlice";
import CurrentUserReducer from "../Slice/Common/CurrentUserSlice";
import GetTrialPlanReducer from "../Slice/Plans/GetTrialPlanSlice";
import GetConversationMetricsReducer from "../Slice/Dashboard/CustomerDashboard/GetConversationMetricsSlice";
import GetTotalBotFailureReducer from "../Slice/Dashboard/CustomerDashboard/GetTotalBotFailureSlice";
import GetCallSummaryReducer from "../Slice/Dashboard/CustomerDashboard/GetCallSummarySlice";
import GetCountCreditAvailableReducer from "../Slice/Dashboard/CustomerDashboard/GetCountCreditAvailableSlice";
import GetCountCreditUsedReducer from "../Slice/Dashboard/CustomerDashboard/GetCountCreditUsedSlice";
import GetReportCountMetricsReducer from "../Slice/Report/Customer/GetReportCountMetricsSlice";
import GetReportDayWiseCallsReducer from "../Slice/Report/Customer/GetReportDayWiseCallsSlice";
import GetReportHourlyCallsReducer from "../Slice/Report/Customer/GetReportHourlyCallsSlice";
import GetReportCallDurationReducer from "../Slice/Report/Customer/GetReportCallDurationSice";
import GetCreditUsedByCustomerReducer from "../Slice/Dashboard/AdminDashboard/GetCreditUsedByCustomerSlice";
import GetUserPlanReducer from "../Slice/Plans/GetUserPlanSlice";
import DocumentsListReducer from "../Slice/Documents/AssistantDocumentListSlice";
import GenerateCustomerApiCredentialReducer from "../Slice/Customers/GenerateCustomerApiCredentialSlice";
import GetContactGroupListReducer from "../Slice/Contacts/Contact Group/GetContactGroupListSlice";
import GetContactGroupByIdReducer from "../Slice/Contacts/Contact Group/GetContactGroupByIdSlice";
import ContactGroupMembersListReducer from "../Slice/Contacts/Contact Group/ContactGroupMembersListSlice";
import GroupChatListReducer from "../Slice/Chats/GroupChatListSlice";
import ChatSummaryListReducer from "../Slice/Chats/ChatSummaryListSlice";
import GetWebsiteWidgetLinkReducer from "../Slice/Assistant/WebsiteWidget/GetWebsiteWidgetLinkSlice";
import GetPlanTypeReducer from "../Slice/Plans/GetPlanTypeSlice";
import GetVariableListReducer from "../Slice/Assistant/GetVariableListSlice";
import GetAssistantFormReducer from "../Slice/Form/GetAssistantFormSlice";
import GetAllFormSubmissionsReducer from "../Slice/Form/GetAllFormSubmissionsSlice";
import GetFormSubmissionDetailReducer from "../Slice/Form/GetFormSubmissionDetailSlice";
import GetPhoneNumberListReducer from "../Slice/PhoneNumbers/GetPhoneNumberListSlice";
import GetCallHistoryListReducer from "../Slice/CallEmailHistory/GetCallHistoryListSlice";
import GetFunctionsListReducer from "../Slice/Functions/GetFunctionsListSlice";
import GetUserLinkAccountReducer from "../Slice/Integration/GetUserLinkAccountSlice";
import WidgetChatReducer from "../Slice/Chats/WidgetChatSlice";
import GetKnowledgeBaseListReducer from "../Slice/KnowledgeBase/GetKnowledgeBaseListSlice";
import GetPaymentMethodListReducer from "../Slice/PaymentMethod/GetPaymentMethodListSlice";
import GetAllCompanyWithAssistantCountReducer from "../Slice/Assistant/GetAllCompanyWithAssistantCountSlice";
import GetPlanTypeListReducer from "../Slice/PlanType/GetPlanTypeListSlice";
import GetPlanDetailsOfUserReducer from "../Slice/Plans/GetPlanDetailsOfUserSlice";
import GetAssistantCountReducer from "../Slice/Assistant/GetAssistantCountSlice";
import GetIndustryListReducer from "../Slice/Common/GetIndustryListSlice";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    forgotPassword: forgotPasswordReducer,
    signUp: signUpReducer,
    roles: fetchRoles,
    users: fetchUsers,
    userDetails: GetUserById,
    setPassword: setPasswordReducer,
    pagination: paginationReducer,
    plansList: getPlansList,
    setmfa: setMFAReducer,
    customerList: getCustomerListReducer,
    customerData: customerDataReducer,
    customerDetailsbyId: customerDetailsByIdReducer,
    plan: planbyIdReducer,
    stateDetails: getDetailsfromZipcodeReducer,
    featuresList: getFeaturesListReducer,
    assistants: getAssistantListReducer,
    assistantDetails: getAssistantReducer,
    templateList: getTemplatesListReducer,
    transactionsList: getTransactionListReducer,
    transactionsById: getTransactionsByIdReducer,
    contacts: getContactListReducer,
    hasUnsavedChanges: hasUnsavedChanges,
    chatList: ChatListReducer,
    groupChatList: GroupChatListReducer,
    widgetChatList: WidgetChatReducer,
    chatSummaryList: ChatSummaryListReducer,
    chatDetails: ChatDetailsReducer,
    currentUser: CurrentUserReducer,
    trialPlan: GetTrialPlanReducer,
    userPlan: GetUserPlanReducer,
    documentList: DocumentsListReducer,
    customerApiCredential: GenerateCustomerApiCredentialReducer,
    contactGroups: GetContactGroupListReducer,
    currentContactGroup: GetContactGroupByIdReducer,
    contactGroupMembers: ContactGroupMembersListReducer,
    websiteWidgetLinks: GetWebsiteWidgetLinkReducer,
    planTypes: GetPlanTypeReducer,
    variableList: GetVariableListReducer,
    assistantForm: GetAssistantFormReducer,
    allFormSubmissions: GetAllFormSubmissionsReducer,
    submissionDetail: GetFormSubmissionDetailReducer,
    phoneNoList: GetPhoneNumberListReducer,
    callHistoryList: GetCallHistoryListReducer,
    functionsList: GetFunctionsListReducer,
    knowledgeBaseList: GetKnowledgeBaseListReducer,

    // Assistant
    assistantCount: GetAssistantCountReducer,
    
    //Admin Dashboard
    countMetrics: GetCountMetricsReducer,
    revenueSummary: GetRevenueSummaryReducer,
    totalCustomers: GetTotalCustomersReducer,
    totalAmountReceived: GetTotalAmountReceivedReducer,
    creditUsedByCustomer: GetCreditUsedByCustomerReducer,

    //Customer Dashboard
    conversationMetrics: GetConversationMetricsReducer,
    totalBotFailure: GetTotalBotFailureReducer,
    dashboardCallSummary: GetCallSummaryReducer,
    countCreditAvailable: GetCountCreditAvailableReducer,
    countCreditUsed: GetCountCreditUsedReducer,

    //Reports
    reportCountMetrics: GetReportCountMetricsReducer,
    reportDayWiseCalls: GetReportDayWiseCallsReducer,
    reportHourlyCalls: GetReportHourlyCallsReducer,
    reportCallDuration: GetReportCallDurationReducer,


    //Integration
    linkedAccounts: GetUserLinkAccountReducer,

    //Payment Method
    paymentMethods: GetPaymentMethodListReducer,

    //Super Admin Assistants
    companyWithAssistantCount: GetAllCompanyWithAssistantCountReducer,

    //Plan Type
    planTypeList: GetPlanTypeListReducer,

    //Plan Details by user
    userPlanDetails: GetPlanDetailsOfUserReducer,

    //Get Industry List
    industryList: GetIndustryListReducer,
  },
});
